import React from 'react';
import logo from '../../assets/logo.svg';

export function ThankYouPage() {
  return (
    <div className="min-h-screen bg-[#7B1C14] py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-3xl mx-auto space-y-8">
        {/* Header Section */}
        <div className="text-center mb-8">
          <img 
            src={logo} 
            alt="Spicy Cubes" 
            className="h-16 sm:h-20 md:h-24 mx-auto"
          />
        </div>

        <div className="bg-[#6E1912] rounded-lg shadow-lg p-8 text-center">
          <h2 className="text-3xl font-bold text-[#F7E8CC]">Thank You!</h2>
          <p className="mt-4 text-[#F7E8CC]/80 text-lg">
            We've received your application and will review it shortly.
          </p>
        </div>
      </div>
    </div>
  );
} 